<nz-segmented
  [nzLabelTemplate]="templateRef"
  [nzOptions]="templateOptions"
  (nzValueChange)="onValueChanged($event)">
  <ng-template
    let-option
    #templateRef>
    <span>{{ option.label | transloco }}</span>
  </ng-template>
</nz-segmented>
